import { render, staticRenderFns } from "./PublicWikiView.vue?vue&type=template&id=69a65542&scoped=true"
import script from "./PublicWikiView.vue?vue&type=script&lang=js"
export * from "./PublicWikiView.vue?vue&type=script&lang=js"
import style0 from "./PublicWikiView.vue?vue&type=style&index=0&id=69a65542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a65542",
  null
  
)

export default component.exports